import type { SupportedLanguage } from '@/lib/languageUtils';

/**
 * Every interface language the app ships, for every picker: the header
 * selector, onboarding and account settings. Each kept its own copy before,
 * and two of them stopped at 23 languages when ten more were released.
 * Alphabetical by locale code. `flag` is a flag-icons country code (regional
 * indicator emoji do not render on Chrome for Windows).
 */
export const APP_LANGUAGES: ReadonlyArray<{
  code: SupportedLanguage;
  flag: string;
  label: string;
  short: string;
}> = [
  { code: 'ar',    flag: 'sa', label: 'العربية', short: 'AR' },
  { code: 'bg',    flag: 'bg', label: 'Български',      short: 'BG' },
  { code: 'cs',    flag: 'cz', label: 'Čeština',        short: 'CS' },
  { code: 'da',    flag: 'dk', label: 'Dansk',          short: 'DA' },
  { code: 'de',    flag: 'de', label: 'Deutsch',        short: 'DE' },
  { code: 'el',    flag: 'gr', label: 'Ελληνικά',       short: 'EL' },
  { code: 'en',    flag: 'gb', label: 'English',        short: 'EN' },
  { code: 'es',    flag: 'es', label: 'Español',        short: 'ES' },
  { code: 'et',    flag: 'ee', label: 'Eesti',          short: 'ET' },
  { code: 'fi',    flag: 'fi', label: 'Suomi',          short: 'FI' },
  { code: 'fil',   flag: 'ph', label: 'Tagalog',        short: 'FIL' },
  { code: 'fr',    flag: 'fr', label: 'Français',       short: 'FR' },
  { code: 'hi',    flag: 'in', label: 'हिन्दी', short: 'HI' },
  { code: 'hr',    flag: 'hr', label: 'Hrvatski',       short: 'HR' },
  { code: 'hu',    flag: 'hu', label: 'Magyar',         short: 'HU' },
  { code: 'id',    flag: 'id', label: 'Bahasa',         short: 'ID' },
  { code: 'it',    flag: 'it', label: 'Italiano',       short: 'IT' },
  { code: 'ja',    flag: 'jp', label: '日本語',          short: 'JA' },
  { code: 'ko',    flag: 'kr', label: '한국어',          short: 'KO' },
  { code: 'lt',    flag: 'lt', label: 'Lietuvių',       short: 'LT' },
  { code: 'lv',    flag: 'lv', label: 'Latviešu',       short: 'LV' },
  { code: 'nl',    flag: 'nl', label: 'Nederlands',     short: 'NL' },
  { code: 'pl',    flag: 'pl', label: 'Polski',         short: 'PL' },
  { code: 'pt-br', flag: 'br', label: 'Português (BR)', short: 'PT-BR' },
  { code: 'pt-pt', flag: 'pt', label: 'Português (PT)', short: 'PT-PT' },
  { code: 'ro',    flag: 'ro', label: 'Română',         short: 'RO' },
  { code: 'sk',    flag: 'sk', label: 'Slovenčina',     short: 'SK' },
  { code: 'sl',    flag: 'si', label: 'Slovenščina',    short: 'SL' },
  { code: 'sv',    flag: 'se', label: 'Svenska',        short: 'SV' },
  { code: 'th',    flag: 'th', label: 'ไทย',            short: 'TH' },
  { code: 'tr',    flag: 'tr', label: 'Türkçe',         short: 'TR' },
  { code: 'uk',    flag: 'ua', label: 'Українська',     short: 'UK' },
  { code: 'vi',    flag: 'vn', label: 'Tiếng Việt',     short: 'VI' },
];
